export const noteRole = (note) => /^\s*⚠/.test(note) ? 'error' : 'note';

export const scenarioCreatedText = (count, groupCount = 0) => 'Scenario created: ' + count + ' block' + (count > 1 ? 's' : '') + ' added to the canvas'
    + (groupCount > 0 ? ' in ' + groupCount + ' scenario' + (groupCount > 1 ? 's' : '') : '') + '.';

export const canResumeEntry = (entry) => entry.source === 'ai' && (entry.status === 'ready' || entry.status === 'clarification');

export const buildConversationChain = (entry, entries) => {
    const byId = new Map(entries.map((item) => [item.id, item]));
    const chain = [];
    const seen = new Set();
    let current = entry;

    while (current && !seen.has(current.id)) {
        seen.add(current.id);
        chain.unshift(current);
        current = current.previousEntryId ? byId.get(current.previousEntryId) : null;
    }

    return chain;
};

export const conversationFromChain = (chain) => {
    const apiHistory = [];
    const bubbles = [];

    for (const item of chain) {
        apiHistory.push({ role: 'user', content: item.prompt });
        bubbles.push({ role: 'user', text: item.prompt, stats: null, historyId: null });

        if (item.status === 'clarification') {
            apiHistory.push({ role: 'assistant', content: item.message });
            bubbles.push({ role: 'assistant', text: item.message, stats: item.stats, historyId: item.id });
            continue;
        }

        apiHistory.push({ role: 'assistant', content: JSON.stringify(item.groups && item.groups.length > 0 ? { status: 'ready', groups: item.groups, steps: item.steps, notes: item.notes } : { status: 'ready', steps: item.steps, notes: item.notes }) });
        bubbles.push({ role: 'assistant', text: scenarioCreatedText(item.steps.length, (item.groups || []).length), stats: item.stats, historyId: item.id });
        for (const note of item.notes || []) {
            bubbles.push({ role: noteRole(note), text: note, stats: null, historyId: null });
        }
    }

    return { apiHistory, bubbles };
};
